/**
 * Alert <uo-placeholder>
 */

// Import style
import './style.scss';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';

// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uo-placeholder' )
export class AutomatorPlaceholder extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String } ) accessor width;

	@property( { type: String } ) accessor height;

	// eslint-disable-next-line require-jsdoc
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="placeholder"
				style="
					${ isDefined( this.width ) ? `width: ${ this.width };` : '' }
					${ isDefined( this.height ) ? `height: ${ this.height };` : '' }
				"
			></div>
		`;
	}
}